// extracted by mini-css-extract-plugin
module.exports = {"container":"home__container","imgHolder":"home__imgHolder","img":"home__img","tagline":"home__tagline","nico":"home__nico"};